export interface SavedFieldKey {
  key: string;
  description: string;
}

export const SAVED_FIELD_KEYS: SavedFieldKey[] = [
  // User/Person Linking Fields
  { key: 'originSubmitterId', description: 'Links to the submitter user by their origin ID' },
  { key: 'originSubmitterEmail', description: 'Links to the submitter user by email address' },
  { key: 'submitterEmail', description: 'Alternative field for submitter email matching' },
  { key: 'originOwnerId', description: 'Links to the owner/admin user by their origin ID' },
  { key: 'originOwnerEmail', description: 'Links to the owner user by email address' },
  { key: 'originOwnerName', description: 'Links to the owner user by name' },
  { key: 'originContactId', description: 'Links to the contact user by their origin ID' },
  { key: 'originLeadId', description: 'Links to the lead user by their origin ID' },
  // Organization Linking Fields
  { key: 'originOrgId', description: 'Links to organization by origin ID' },
  { key: 'originOrgIds', description: 'Array of organization IDs for multiple org relationships' },
  { key: 'originOrgName', description: 'Links to organization by name' },
  { key: 'externalOrgId', description: 'Alternative organization ID field' },
  { key: 'clientName', description: 'Links to organization by client name' },
  { key: 'companyName', description: 'Links to organization by company name' },
  // Component Linking Fields
  {
    key: 'componentText',
    description: 'Links to component by text value (matches component name)',
  },
  { key: 'componentString', description: 'Alternative field for component text matching' },
  // Item Linking Fields
  { key: 'linkedItemOriginId', description: 'Links to another CX item by origin ID' },
  // Evidence-Specific Linking Fields
  { key: 'evidenceIdeaId', description: 'Links evidence to an idea by idea ID' },
  { key: 'evidenceIdeaState', description: 'State value for evidence-idea relationship' },
  // Mapped Output Fields (read-only, auto-populated)
  {
    key: 'submitterId',
    description: 'Auto-populated submitter user ID (from originSubmitterId/Email)',
  },
  { key: 'submitterName', description: 'Auto-populated submitter name' },
  { key: 'ownerId', description: 'Auto-populated owner user ID (from originOwnerId/Email/Name)' },
  { key: 'orgId', description: 'Auto-populated organization ID (from originOrgId/Name)' },
  { key: 'componentId', description: 'Auto-populated component ID (from componentText/String)' },
];

// Helper function to check if a field is a saved field key
export const SAVED_FIELDS_MAP: Record<string, SavedFieldKey> = SAVED_FIELD_KEYS.reduce(
  (acc, item) => {
    acc[item.key] = item;
    return acc;
  },
  {} as Record<string, SavedFieldKey>,
);

// Helper function to check if a field is a saved field key
export const isSavedFieldKey = (fieldKey: string): boolean => {
  return fieldKey in SAVED_FIELDS_MAP;
};

// Helper function to get description for a saved field key
export const getSavedFieldDescription = (fieldKey: string): string | undefined => {
  return SAVED_FIELDS_MAP[fieldKey]?.description;
};
